import { useCallback, useEffect, useState } from 'react';
import {
  appendExternalAccessTokenQuery,
  ensureExternalAccessFresh,
  getExternalAccessToken,
} from './api';

/**
 * Подготавливает URL фото с ?token= (external JWT) для <img src={...}>.
 * Поле blobUrl — историческое имя, это обычный https-URL, не blob:.
 */
export function useAuthenticatedBlobUrl(resourceUrl: string | null, enabled = true) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !resourceUrl) {
      setBlobUrl(null);
      setError(false);
      setLoading(false);
      return;
    }

    let cancelled = false;

    setLoading(true);
    setError(false);
    setBlobUrl(null);

    ensureExternalAccessFresh()
      .then(() => {
        if (cancelled) return;
        const token = getExternalAccessToken();
        if (!token) {
          setError(true);
          return;
        }
        setBlobUrl(appendExternalAccessTokenQuery(resourceUrl, token));
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [resourceUrl, enabled]);

  const onImageError = useCallback(() => setError(true), []);

  return { blobUrl, loading, error, onImageError };
}
